import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import HeaderWithoutLogin from "../components/HeaderWithoutLogin";
import AccountDetailsForm from "../components/AccountDetailsForm/AccountDetailsForm";
import Card from "../components/Card/Card";
import CustomButton from "../components/CustomButton/CustomButton";
import { saveUserAccountDetails, setUserSignupedData } from "../redux/actions";
import CustomAlertLabel from "../components/CustomAlertLabel/CustomAlertLabel";
import LoadingBar from "../components/LoadingBar/LoadingBar";
import { Auth } from "aws-amplify";

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  .formContainer {
    width: 80%;
    margin-top: 3%;
  }

  @media (max-width: 480px) {
    .formContainer {
      width: 100%;
    }
  }

  .buttonContainer {
    width: 90%;
    text-align: right;
    margin-top: 15px;
  }
`;

const AccountDetails = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { setUserAccountDetails, loginSuccessResponse } = useSelector(
    (state) => state.user
  );

  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [nickName, setNickName] = useState();
  const [phone, setPhone] = useState();
  const [secondEmail, setSecondEmail] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoaded, setIsLoaded] = useState(isLoading);
  const [customAlertMessage, setCustomAlertMessage] = useState("");
  const [phoneNoAgree, setPhoneNoAgree] = useState(false);

  const handleAgreementClick = () => {
    setPhoneNoAgree(!phoneNoAgree);
  };

  const handleNextButtonClick = async () => {
    if (firstName && lastName && phone && secondEmail && phoneNoAgree) {
      var payload = {
        firstName: firstName,
        lastName: lastName,
        nickname: nickName || "",
        phone: phone,
        secondEmail: secondEmail,
      };
      setIsLoading(true);
      dispatch(saveUserAccountDetails(payload));
      setCustomAlertMessage("");
      await Auth.updateUserAttributes(loginSuccessResponse, {
        phone_number: `+1${phone}`,
      });
      Auth.setPreferredMFA(loginSuccessResponse, "SMS");
    } else {
      let errorCount =
        Number(!secondEmail) +
        Number(!firstName) +
        Number(!lastName) +
        Number(!phone) +
        Number(!phoneNoAgree);

      let errorMessage = `${!secondEmail ? "Recovery email, " : ""}${
        !firstName ? "First name, " : ""
      }${!lastName ? "Last name, " : ""}${!phone ? "Mobile Phone, " : ""}${
        !phoneNoAgree ? "Phone no agreement, " : ""
      } ${errorCount > 1 ? "are" : "is a "} mandatory field${
        errorCount > 1 ? "s" : ""
      }`.replace(",", `${errorCount == 1 ? " " : ","}`);

      if (errorMessage.indexOf("are") !== -1)
        setCustomAlertMessage(
          errorMessage.slice(0, errorMessage.indexOf("are") - 3) +
            " " +
            errorMessage.slice(errorMessage.indexOf("are"), errorMessage.length)
        );
      else setCustomAlertMessage(errorMessage);
    }
  };

  const handleCustomTextBoxOnBlur = (textBoxName, value) => {
    if (textBoxName === "firstName") {
      setFirstName(value);
    } else if (textBoxName === "lastName") {
      setLastName(value);
    } else if (textBoxName === "nickName") {
      setNickName(value);
    } else if (textBoxName === "phoneNo") {
      setPhone(value);
    } else if (textBoxName === "secondEmail") {
      setSecondEmail(value);
    }
  };

  const handleCustomTextBoxKeyPress = (event) => {
    if (event.key === "Enter") {
      handleNextButtonClick();
    }
  };

  useEffect(() => {
    dispatch(setUserSignupedData());
  }, [dispatch]);

  useEffect(() => {
    if (setUserAccountDetails) {
      setIsLoading(false);
      if (setUserAccountDetails.id) {
        history.push("/terms-of-services");
      }
    }
  }, [setUserAccountDetails, history]);

  return (
    <>
      <HeaderWithoutLogin
        isHomeClickable={false}
        isLogOutButtonVisible={true}
      />
      {(isLoaded || isLoading) && (
        <LoadingBar isLoading={isLoading} setIsLoaded={setIsLoaded} />
      )}
      <BodyWrapper>
        <div className="formContainer">
          <Card>
            {
              <AccountDetailsForm
                handleCustomTextBoxOnBlur={handleCustomTextBoxOnBlur}
                handleCustomTextBoxKeyPress={handleCustomTextBoxKeyPress}
                handleAgreementClick={handleAgreementClick}
                phoneNoAgree={phoneNoAgree}
              />
            }
          </Card>
        </div>
        <div className="buttonContainer">
          <CustomButton text="Next" onClick={handleNextButtonClick} />
          <CustomAlertLabel message={customAlertMessage} />
        </div>
      </BodyWrapper>
    </>
  );
};

export default AccountDetails;
